import { render, staticRenderFns } from "./CourseStatisticTable.vue?vue&type=template&id=156d745a&"
import script from "./CourseStatisticTable.vue?vue&type=script&lang=js&"
export * from "./CourseStatisticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports